
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("90bwg", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $91ce4a8b7c2c9b2e$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "DraftLozenge", () => $91ce4a8b7c2c9b2e$export$86b665ce7b1d6912);
/* DraftLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $5nBzc = parcelRequire("5nBzc");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91ce4a8b7c2c9b2e$var$StatusLozengeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18u01b66 _zg8l4jg8",
            __cmplp.className
        ])
    });
});
const $91ce4a8b7c2c9b2e$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    draftLozengeText: {
        id: "page-tree.status.draft",
        defaultMessage: "DRAFT"
    }
});
const $91ce4a8b7c2c9b2e$export$86b665ce7b1d6912 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($91ce4a8b7c2c9b2e$var$StatusLozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $91ce4a8b7c2c9b2e$export$a7357cdd1f0b0168.draftLozengeText, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            "data-testid": "draft-status-lozenge"
        }, message))));

});


//# sourceMappingURL=DraftLozenge.b210c68f.js.map
